import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { SHOW_FEEDBACK_BUTTON, DEFAULT_PROFILE_PICTURE } from "../../constants";
import { DomSanitizer } from "@angular/platform-browser";
import { Observable } from 'rxjs/Observable';

import {
  Translate,
  Utils,
} from '../../services';

@Component({
  selector: 'cs-user-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div 
      class="cs-userbar"
      [style.background-color]="inputs.sectionColor">
      <div *ngIf="!inputs.trainingMode">
        <img 
          alt="" 
          class="cs-userbar__thumb"
          [src]="profilePicture"
          (click)="expandImage.emit(profilePicture)"
          >
  
        <p class="cs-userbar__name">
          {{ inputs.user?.name }}
        </p>
  
        <p class="cs-userbar__born">
          <span class="cs-label">{{ (translations$ | async)['global#born'] }}</span>
          <span class="cs-value">{{ inputs.user?.birthday }}</span>
          <span class="cs-label">{{ (translations$ | async)['global#in'] }}</span>
          <span class="cs-value">{{ inputs.user?.birthPlace }}</span>
        </p>
  
        <p class="cs-userbar__cf">
          <span class="cs-label">CF</span>
          <span class="cs-value">{{ inputs.user?.codFisc }}</span>
        </p>
      </div>

      <div class="cs-userbar__tools">
        <button 
          class="cs-btn cs-btn-light cs-btn-no-click"
          title="Premi i tasti Ctrl+ per aumentare lo zoom"
          *ngIf="isIE">
          <img src="assets/img/icon-zoom-in.png" alt="" width="20" height="20">
        </button><!--
        --><button 
          class="cs-btn cs-btn-light cs-btn-no-click"
          title="Premi i tasti Ctrl- per diminuire lo zoom"
          *ngIf="isIE">
          <img src="assets/img/icon-zoom-out.png" alt="" width="20" height="20">
        </button><!--
        --><button 
          class="cs-btn cs-btn-light"
          (click)="increaseZoom.emit()"
          *ngIf="!isIE">
          <img src="assets/img/icon-zoom-in.png" alt="" width="20" height="20">
        </button><!--
        --><button
          class="cs-btn cs-btn-light"
          (click)="decreaseZoom.emit()"
          *ngIf="!isIE">
          <img src="assets/img/icon-zoom-out.png" alt="" width="20" height="20">
        </button><!--
        --><button
          class="cs-btn cs-btn-light cs-userbar__tools-contrast"
          (click)="highContrastToggle.emit()"
          *ngIf="inputs.user?.isDisabled">
          Alto contrasto
        </button><!--
        --><a
          class="cs-btn cs-btn-light"
          (click)="openHelp.emit()"
          *ngIf="inputs.showHelp">
          Help <span class="ion-help-buoy"></span>
        </a><!--
        --><a
          *ngIf="showFeedbackButton"
          class="cs-btn cs-btn-light"
          href="{{
            inputs.feedbackUrl + 
            '?info=' + inputs.user.userId + 
            '-' + inputs.user.testId +
            trainingInfo + (inputs.trainingMode ? '1' : '0')
          }}"
          target="_blank"
          [style.cursor]="'alias'">
          {{ (translations$ | async)['global#feedback'] }} <span class="ion-android-open"></span>
        </a>
        <button 
          *ngIf="isMobile"
          (click)="exit()"
          class="cs-btn cs-btn-light"
          title="Esci dal test">
          <span *ngIf="!exitLoading" class="ion-power"></span>
          <img *ngIf="exitLoading" src="assets/img/ajax-loader.gif" alt="" width="20" height="20">
        </button>
      </div>
    </div>
  `
})

export class CsUserBarComponent {
  @Input() inputs: Object;
  @Output() openHelp = new EventEmitter<Object>();
  @Output() highContrastToggle = new EventEmitter<Object>();
  @Output() increaseZoom = new EventEmitter<Object>();
  @Output() decreaseZoom = new EventEmitter<Object>();
  @Output() expandImage = new EventEmitter<Object>();

  translations$: Observable<any> = this.translate.getTranslations$();
  showFeedbackButton = SHOW_FEEDBACK_BUTTON;
  profilePicture;

  isIE = false;
  trainingInfo = '&a=';
  profileImageSrc = '';
  isMobile: boolean = false;
  exitLoading: boolean = false;

  constructor(
    private translate: Translate,
  	private sanitizer: DomSanitizer,
    private utils: Utils,
  ) {
    this.isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
    this.isMobile = this.utils.isMobile();
  }

  ngOnInit() {
    let pp = typeof this.inputs['user'] !== 'undefined' && this.inputs['user'].profileImage !== 'undefined' ? this.inputs['user'].profileImage : undefined;
    let ppp = this.getProfilePictureUrl(pp);
    this.profilePicture = this.sanitizer.bypassSecurityTrustResourceUrl(ppp);
  }

  getProfilePictureUrl(profileImage) {
    if (typeof profileImage !== 'undefined' &&
      profileImage !== null &&
      profileImage.length > 0) {
      return 'data:image/jpg;base64,' + profileImage;
    }
    return '' + DEFAULT_PROFILE_PICTURE;
  }

  exit(){
    this.exitLoading = true;

    setTimeout(() => {
      // window.location.href = '';
      window.location.reload(true);
    }, 3000);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cs-user-bar/cs-user-bar.component.ts